import AdminAddEntityTagPopoverContent, {
  AdminAddEntityTagPopoverContentProps,
} from "@/admin/settings/tabs/AdminAddEntityTagPopoverContent"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { Popover, PopoverProps } from "@material-ui/core"
import { TestIDProps } from "@utils/typeUtils"

type Props = TestIDProps &
  Pick<PopoverProps, "anchorEl" | "onClose"> &
  AdminAddEntityTagPopoverContentProps

function AdminAddEntityTagPopover({
  testid = "AdminAddEntityTagPopover",
  anchorEl,
  onClose,
  ...popoverContentProps
}: Props) {
  const classes = useStyles()

  if (!anchorEl) return null

  return (
    <Popover
      data-testid={testid}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorEl={anchorEl}
      disablePortal
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      classes={{ paper: classes.popoverPaper }}
    >
      <AdminAddEntityTagPopoverContent {...popoverContentProps} />
    </Popover>
  )
}

const useStyles = makeUseStyles((theme) => ({
  popoverPaper: {
    width: "400px",
    maxHeight: "80vh",
    borderRadius: theme.measure.borderRadius.big,
    boxShadow: theme.palette.groovyDepths.boxShadow,
    border: theme.palette.constants.borderSmall,
    zIndex: 10000,
  },
}))

export default AdminAddEntityTagPopover
